import { render, staticRenderFns } from "./aRoomDetailComplaint.vue?vue&type=template&id=aa974900&scoped=true"
import script from "./aRoomDetailComplaint.vue?vue&type=script&lang=js"
export * from "./aRoomDetailComplaint.vue?vue&type=script&lang=js"
import style0 from "./aRoomDetailComplaint.vue?vue&type=style&index=0&id=aa974900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa974900",
  null
  
)

export default component.exports